import classNames from 'classnames';
import type { ReactNode } from 'react';

export type TextInputLabelProps = {
  label?: string;
  htmlFor?: string;
  children?: ReactNode;
};

export const TextInputLabel = ({ label, htmlFor, children }: TextInputLabelProps) => {
  if (label) {
    return (
      <label htmlFor={htmlFor} className={classNames('mb-4', 'block')}>
        <span>{label}</span>
        {children}
      </label>
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
